<template>
    <div>
        <loading
            :active.sync="loading.content"
            :can-cancel="false"
            :is-full-page="true"
            :color="'#0B8BCC'"
            :loader="'dots'"
            :opacity="0.7"
            :lock-scroll="true"
        ></loading>
        <Toast
            :show.sync="toast.show"
            :message="toast.message"
            :tipe="toast.tipe"
            :position="toast.position"
            :icon="toast.icon"
        ></Toast>
        <!-- App Header -->
        <div class="appHeader bg-primary text-light shadow-header-footer">
            <div class="left">
                <router-link
                    v-if="this.operator_selected != undefined"
                    :to="{
                        name: 'prabayar-special-product',
                        params: {
                            id: this.group_id, // group id
                        },
                    }"
                    class="headerButton"
                >
                    <ion-icon name="chevron-back-outline"></ion-icon>
                </router-link>
            </div>
            <div class="pageTitle">
                {{ data_operator_selected.prabayar_category.product_name }}
            </div>
        </div>
        <!-- * App Header -->

        <div id="appCapsule">
            <!-- Form -->
            <div class="section inset mt-2">
                <div class="form-group boxed p-0 mb-2">
                    <div class="input-wrapper">
                        <label
                            class="label"
                            v-if="
                                data_operator_selected.label_input == '' ||
                                data_operator_selected.label_input == null ||
                                data_operator_selected.label_input == undefined
                            "
                            >No. Pengisian</label
                        >
                        <label class="label" v-else>{{
                            data_operator_selected.label_input
                        }}</label>
                        <input
                            type="text"
                            class="form-control form-control-lg"
                            v-if="data_operator_selected.type_input == 'STRING'"
                            v-model="data_order.destination"
                        />
                        <input
                            type="number"
                            class="form-control form-control-lg"
                            v-else
                            v-model="data_order.destination"
                        />

                        <ButtonLoader
                            :loading="loading.button_check_pln"
                            :styled="'custom-botton-inside btn-primary'"
                            :type_loader="'spin'"
                            @click.native="checkButton()"
                            v-if="
                                data_operator_selected.prabayar_category
                                    .product_id == 'TPLN'
                            "
                            >Cek</ButtonLoader
                        >
                        <i class="clear-input" v-else>
                            <ion-icon
                                name="close-circle"
                                @click="clearDestination()"
                            ></ion-icon>
                        </i>
                    </div>

                    <div class="mt-1">
                        <div
                            class="chip chip-media"
                            style="font-size: 11px; background: #efefef"
                            @click="openPhoneBook()"
                        >
                            <i class="chip-icon bg-primary">
                                <ion-icon name="journal-outline"></ion-icon>
                            </i>
                            <span class="chip-label">Kontak</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Element Pilih Operator -->
            <div class="section full mt-1">
                <ul class="listview image-listview inset">
                    <li>
                        <div class="item">
                            <img
                                v-lazyload
                                v-if="
                                    data_operator_selected.icon != '' ||
                                    data_operator_selected.icon != null
                                "
                                :src="require('@/assets/Loader-2.png')"
                                :data-src="
                                    data_operator_selected.icon != ''
                                        ? VUE_ENV.VUE_APP_ASSET_URL +
                                          '/img/icon/operator/' +
                                          data_operator_selected.icon
                                        : require('@/assets/Loader-2.png')
                                "
                                alt="image"
                                class="image"
                            />
                            <div class="in">
                                <div>
                                    <b>{{
                                        data_operator_selected.product_name
                                    }}</b>
                                    <footer>
                                        {{ data_operator_selected.description }}
                                    </footer>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>

            <!-- Detail Pelanggan  -->
            <div
                class="section inset mt-2"
                v-if="
                    data_checking.nama_pelanggan != '' &&
                    data_checking.tarif_daya != ''
                "
            >
                <div class="wide-block pt-2 pb-2 pl-3 pr-3">
                    <div class="content-header mb-1">Detail Pelanggan</div>
                    <div class="row">
                        <div class="col-6">Nama</div>
                        <div class="col-6">
                            <b>{{ data_checking.nama_pelanggan }}</b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6">Tarif/Daya</div>
                        <div class="col-6">
                            <b>{{ data_checking.tarif_daya }}</b>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Loading Product -->
            <div
                class="text-center"
                v-if="loading.list_product"
                :class="
                    data_operator_selected.varian != null &&
                    data_operator_selected.varian != ''
                        ? 'mt-2'
                        : 'mt-3'
                "
            >
                <span
                    class="spinner-border spinner-border-sm mr-1"
                    role="status"
                    aria-hidden="true"
                ></span>
            </div>

            <!-- list product -->
            <div
                v-else-if="loading.list_product == false && product.length > 0"
                :class="
                    data_operator_selected.varian != null &&
                    data_operator_selected.varian != ''
                        ? 'mt-2'
                        : 'mt-3'
                "
            >
                <div v-if="product.length > 0">
                    <!-- Title Header -->
                    <div class="section full mb-2">
                        <div class="section-heading padding mb-1">
                            <h2 class="title" style="font-size: 15px">
                                Pilihan Produk
                            </h2>
                        </div>
                    </div>

                    <!-- // List Product Style List -->
                    <div
                        class="section mt-2"
                        v-if="data_operator_selected.style_product == 'LIST'"
                    >
                        <div class="transactions" v-if="product.length > 0">
                            <div
                                class="mb-2"
                                v-for="item in product"
                                :key="item.id"
                            >
                                <!-- item -->
                                <a
                                    href="javascript:;"
                                    class="item-promo"
                                    :class="
                                        item.status == 'INACTIVE'
                                            ? 'disabled'
                                            : ''
                                    "
                                    style="padding: 15px 10px; height: 100%"
                                    @click="showDetail(item)"
                                >
                                    <div class="detail">
                                        <div style="color: #17273e">
                                            <div class="product-name">
                                                {{ item.product_name }}
                                            </div>
                                            <div class="product-description">
                                                {{ item.description }}
                                            </div>
                                            <div
                                                class="product-price-strikeout"
                                                :style="
                                                    item.status == 'INACTIVE'
                                                        ? 'color:#726d79;'
                                                        : ''
                                                "
                                            >
                                                Rp
                                                {{
                                                    item.price_strikeout
                                                        | rupiah
                                                }}
                                            </div>
                                            <div
                                                class="product-price"
                                                :style="
                                                    'font-weight:bold;' +
                                                        item.status ==
                                                    'INACTIVE'
                                                        ? 'color:#726d79;'
                                                        : ''
                                                "
                                            >
                                                Rp {{ item.price | rupiah }}
                                            </div>
                                        </div>
                                    </div>

                                    <div class="right">
                                        <div class="label-promo">
                                            -{{
                                                calculateDiscount(
                                                    item.price_strikeout,
                                                    item.price
                                                )
                                            }}%
                                        </div>
                                        <div
                                            class="poin"
                                            v-if="item.points > 0"
                                        >
                                            +{{ item.points }} points
                                        </div>
                                    </div>
                                </a>
                                <!-- * item -->
                            </div>
                        </div>
                    </div>

                    <!-- // List Product Style GRID -->
                    <div class="section mt-2" v-else>
                        <div class="transactions" v-if="product.length > 0">
                            <div class="row">
                                <div
                                    class="col-6 mb-2"
                                    v-for="item in product"
                                    :key="item.id"
                                >
                                    <!-- item -->
                                    <a
                                        href="javascript:;"
                                        class="item-promo"
                                        :class="
                                            item.status == 'INACTIVE'
                                                ? 'disabled'
                                                : ''
                                        "
                                        style="padding: 15px 10px; height: 100%"
                                        @click="showDetail(item)"
                                    >
                                        <div class="detail">
                                            <div>
                                                <div class="product-name">
                                                    {{ item.product_name }}
                                                </div>
                                                <div
                                                    class="product-price-strikeout"
                                                    :style="
                                                        item.status ==
                                                        'INACTIVE'
                                                            ? 'color:#726d79;'
                                                            : ''
                                                    "
                                                    v-if="
                                                        item.price_strikeout !=
                                                        null
                                                    "
                                                >
                                                    Rp
                                                    {{
                                                        item.price_strikeout
                                                            | rupiah
                                                    }}
                                                </div>
                                                <div
                                                    class="product-price"
                                                    :class="
                                                        item.price_strikeout ==
                                                        null
                                                            ? 'mt-1'
                                                            : ''
                                                    "
                                                    :style="
                                                        item.status ==
                                                        'INACTIVE'
                                                            ? 'color:#726d79;'
                                                            : ''
                                                    "
                                                >
                                                    Rp {{ item.price | rupiah }}
                                                </div>
                                            </div>
                                        </div>

                                        <div class="right">
                                            <div class="label-promo">
                                                -{{
                                                    calculateDiscount(
                                                        item.price_strikeout,
                                                        item.price
                                                    )
                                                }}%
                                            </div>
                                            <div
                                                class="poin"
                                                v-if="item.points > 0"
                                            >
                                                +{{ item.points }} points
                                            </div>
                                        </div>
                                    </a>
                                    <!-- * item -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center mt-1" v-else>
                <img
                    :src="require('@/assets/image/empty.webp')"
                    alt="empty"
                    style="width: 65%"
                /><br />
                <h2 class="mb-0">Belum Ada Data</h2>
                <p>Tidak ada data yang dapat ditampilkan</p>
            </div>
            <!-- * Form -->
        </div>

        <!-- Modal detail produk -->
        <action-sheet
            ref="modalDetailProduct"
            :title="'Detail Produk'"
            :header="false"
            :inset="false"
            :content-height="true"
        >
            <div style="border-bottom: 1px dashed #dee2e6">
                <h4 style="margin-bottom: 0px">
                    {{ product_select.product_name }}
                </h4>
                <label class="label" style="font-size: 13px"
                    >{{
                        data_operator_selected.prabayar_category.product_name
                    }}
                    • {{ data_operator_selected.product_name }}</label
                >
                <div
                    class="alert alert-grey-custom mb-2 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <div><b>Harga Beli</b></div>
                            <p
                                class="mb-0"
                                v-if="product_select.price_strikeout != null"
                            >
                                <small
                                    >Kamu menghemat
                                    <b
                                        style="
                                            color: #ff6c00;
                                            font-weight: bold;
                                        "
                                    >
                                        Rp
                                        {{
                                            (product_select.price_strikeout -
                                                product_select.price)
                                                | rupiah
                                        }}
                                        (-{{
                                            calculateDiscount(
                                                product_select.price_strikeout,
                                                product_select.price
                                            )
                                        }}%)</b
                                    ></small
                                >
                            </p>
                        </div>
                        <div class="text-right">
                            <div v-if="product_select.price_strikeout != null">
                                <s
                                    >Rp
                                    {{
                                        product_select.price_strikeout | rupiah
                                    }}</s
                                >
                            </div>
                            <div
                                style="
                                    font-size: 15px;
                                    color: #17273e;
                                    font-weight: 700;
                                    margin-top: 3px;
                                "
                            >
                                Rp {{ product_select.price | rupiah }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div
                class="pt-2 pb-2"
                style="
                    border-bottom: 1px dashed #dee2e6;
                    line-height: 1.3;
                    white-space: pre-line;
                "
                v-if="product_select.description"
            >
                <div
                    style="font-size: 11px"
                    v-html="product_select.description"
                ></div>
            </div>
            <div
                class="pt-2"
                style="border-bottom: 1px dashed #dee2e6; line-height: 1.3"
                v-if="product_select.full_description"
            >
                <div
                    style="font-size: 11px"
                    v-html="product_select.full_description"
                ></div>
            </div>
            <div class="form-group basic mt-1 pb-0">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="hideDetail()"
                        >
                            Nanti
                        </button>
                    </div>
                    <div class="col-6">
                        <button
                            class="btn btn-primary btn-block btn-lg"
                            style="height: 40px"
                            @click="showConfirm(product_select)"
                        >
                            Beli
                        </button>
                    </div>
                </div>
            </div>
        </action-sheet>

        <!-- Modal konfirmasi pembelian -->
        <action-sheet
            ref="modalConfirmation"
            :title="'Konfirmasi Pembelian'"
            :header="true"
            :inset="false"
            :content-height="true"
        >
            <div class="mb-1 pb-1" style="border-bottom: 1px dashed #dee2e6">
                <table
                    class="w-100"
                    style="font-size: 13px; line-height: 1.5rem"
                >
                    <tr>
                        <td>Produk</td>
                        <td style="text-align: right">
                            {{
                                data_operator_selected.prabayar_category
                                    .product_name
                            }}
                            •
                            {{ data_operator_selected.product_name }}
                        </td>
                    </tr>
                    <tr>
                        <td>Nominal</td>
                        <td style="text-align: right">
                            {{ this.product_select.product_name }}
                        </td>
                    </tr>
                    <tr>
                        <td>No. Telepon</td>
                        <td style="text-align: right">
                            {{ data_order.destination }}
                        </td>
                    </tr>
                    <tr>
                        <td>Points</td>
                        <td style="text-align: right">
                            <b class="text-warning"
                                >+{{ product_select.points | rupiah }} points</b
                            >
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Atur harga jual -->
            <div
                class="mb-1 mt-1 pb-1"
                style="border-bottom: 1px dashed #dee2e6"
                v-if="customer.balance >= product_select.price"
            >
                <table class="w-100" style="line-height: 1.5rem">
                    <tr>
                        <td style="font-size: 12px">Harga Jual</td>
                        <td width="30%" class="text-right">
                            <div class="form-group mb-0">
                                <input
                                    type="tel"
                                    class="form-control form-control-sm text-right"
                                    v-model="data_order.price_selling"
                                    @input="inputPriceSelling"
                                />
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td style="font-size: 12px">Potensi Keuntungan</td>
                        <td
                            class="text-right text-success"
                            style="padding-top: 10px"
                            v-if="
                                parseInt(
                                    data_order.price_selling.replace('.', '')
                                ) -
                                    product_select.price >
                                0
                            "
                        >
                            Rp
                            {{
                                (parseInt(
                                    data_order.price_selling.replace('.', '')
                                ) -
                                    product_select.price)
                                    | rupiah
                            }}
                        </td>
                        <td
                            class="text-right text-success"
                            style="padding-top: 10px"
                            v-else
                        >
                            Rp 0
                        </td>
                    </tr>
                </table>
            </div>

            <!-- Alert saldo tidak cukup -->
            <div v-if="customer.balance < product_select.price">
                <div
                    class="alert alert-danger-custom mt-1 mb-1 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <b
                                >Saldo kurang! Sisa Rp
                                {{ customer.balance | rupiah }}</b
                            >
                        </div>
                        <span class="text-muted">
                            <button
                                class="btn btn-warning btn-sm rounded shadowed pl-3 pr-3"
                                style="font-size: 12px; height: 30px"
                                @click="redirectDepositPage()"
                            >
                                Isi Saldo
                            </button>
                        </span>
                    </div>
                </div>
            </div>

            <!-- infor harga beli -->
            <div style="border-bottom: 1px dashed #dee2e6">
                <div
                    class="alert alert-grey-custom mb-2 pt-2 pb-2"
                    role="alert"
                >
                    <div class="alert-custom-container">
                        <div class="alert-custom-description">
                            <div><b>Harga Beli</b></div>
                            <p
                                class="mb-0"
                                v-if="product_select.price_strikeout != null"
                            >
                                <small
                                    >Kamu menghemat
                                    <b
                                        style="
                                            color: #ff6c00;
                                            font-weight: bold;
                                        "
                                    >
                                        Rp
                                        {{
                                            (product_select.price_strikeout -
                                                product_select.price)
                                                | rupiah
                                        }}
                                        (-{{
                                            calculateDiscount(
                                                product_select.price_strikeout,
                                                product_select.price
                                            )
                                        }}%)</b
                                    ></small
                                >
                            </p>
                        </div>
                        <div class="text-right">
                            <div v-if="product_select.price_strikeout != null">
                                <s
                                    >Rp
                                    {{
                                        product_select.price_strikeout | rupiah
                                    }}</s
                                >
                            </div>
                            <div
                                style="
                                    font-size: 15px;
                                    color: #17273e;
                                    font-weight: 700;
                                    margin-top: 3px;
                                "
                            >
                                Rp {{ product_select.price | rupiah }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="form-group basic pb-0">
                <div class="row">
                    <div class="col-6">
                        <button
                            class="btn btn-outline-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="hideConfirm()"
                        >
                            Batal
                        </button>
                    </div>
                    <div class="col-6">
                        <ButtonLoader
                            :loading="loading.button_submit"
                            :styled="'btn btn-primary btn-block btn-lg'"
                            style="height: 40px"
                            @click.native="verifyWithoutPin()"
                            :disabled="customer.balance < product_select.price"
                            v-if="customer.pin_trx == 'DISABLED'"
                            >Beli</ButtonLoader
                        >
                        <button
                            class="btn btn-primary btn-block btn-lg"
                            style="height: 40px; border-width: 1px"
                            @click="verifyWithPin()"
                            :disabled="customer.balance < product_select.price"
                            v-else
                        >
                            Beli
                        </button>
                    </div>
                </div>
            </div>
        </action-sheet>

        <!-- Modal Status Pembelian  -->
        <action-sheet ref="status" :title="'Status Pembelian'" :inset="true">
            <div class="iconbox text-success">
                <ion-icon name="checkmark-circle"></ion-icon>
            </div>
            <div class="text-center p-2">
                <h3>Pembayaran Berhasil</h3>
                <p>Transaksi Anda sedang diproses</p>
            </div>
            <div class="form-group basic">
                <button
                    class="btn btn-primary btn-block btn-lg"
                    @click="directToHistory()"
                >
                    Lihat Riwayat Transaksi
                </button>
                <button
                    class="btn btn-outline-primary btn-block btn-lg"
                    @click="hideStatus()"
                >
                    Kembali
                </button>
            </div>
        </action-sheet>

        <Modal
            ref="modalDescriptionOperator"
            :loading="loading.modal"
            :title="'Tutorial & Panduan'"
        >
            <div v-html="data_operator_selected.description_input"></div>
        </Modal>

        <!-- Dialog Update APK -->
        <Dialog
            ref="dialog_update_apk"
            :loading="false"
            :title="'Update Aplikasi'"
            @confirm="updateApk()"
        >
            Aplikasi versi terbaru telah tersedia di playstore. Update Sekarang!
        </Dialog>
    </div>
</template>
<script>
    import $axios from './../../../../api.js';
    import { mapState, mapMutations } from 'vuex';
    export default {
        props: [
            'operator_selected',
            'destination',
            'toast_reference',
            'group_id',
        ],
        data() {
            return {
                loading: {
                    button_submit: false,
                    button_check_pln: false,
                    content: true,
                    modal: false,
                    list_product: false,
                },
                list_price_selling: [],
                operator: [],
                product: [],
                product_select: {},
                varian_select: null,
                activeVarianSelect: null,
                data_checking: {
                    nama_pelanggan: '',
                    tarif_daya: '',
                },
                time: null,
            };
        },
        created() {
            // window.fbq('track', 'ViewContent');
        },
        computed: {
            ...mapState(['customer', 'toast', 'VUE_ENV', 'device']),
            ...mapState('transactionPrabayar', {
                data_order: state => state.data_order,
                data_operator_selected: state => state.data_operator_selected,
            }),
            filterPriceSelling() {
                return this.list_price_selling.filter(
                    item => item.product_id === this.data_order.product_id
                );
            },
            chunkedProduct() {
                return window._.chunk(window._.toArray(this.product), 2);
            },
        },
        methods: {
            ...mapMutations('transactionPrabayar', [
                'SET_DATA_OPERATOR_SELECTED',
                'RESET_DATA_ORDER',
            ]),
            calculateDiscount(price_normal, price_discount) {
                return (
                    ((price_normal - price_discount) / price_normal) *
                    100
                ).toFixed(2);
            },
            selectVarian(varian, value) {
                this.activeVarianSelect = value;
                this.varian_select = varian;
            },
            openPhoneBook() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.openPhoneBook();
                }
            },
            phone(phone) {
                this.data_order.destination = this.$options.filters.filterPhone(
                    phone,
                    ['-', '+'],
                    ['', '']
                );
            },
            updateApk() {
                this.dialogUpdateAPK('hide');
                window.open(
                    'https://play.google.com/store/apps/details?id=com.digifazz.app',
                    '_blank'
                );
            },
            dialogUpdateAPK(value) {
                let element = this.$refs.dialog_update_apk.$el;
                window.$(element).modal(value);
            },
            inAppReview() {
                if (typeof window.AndroidNative !== 'undefined') {
                    window.AndroidNative.inAppReview();
                }
            },
            clearDestination() {
                if (this.data_order.destination != '') {
                    this.data_order.destination = '';
                }
            },
            modalDescriptionOperator(value) {
                let element = this.$refs.modalDescriptionOperator.$el;
                window.$(element).modal(value);
            },
            showDetail(item) {
                const label_input =
                    this.data_operator_selected.label_input != null
                        ? this.data_operator_selected.label_input
                        : 'No. Pengisian';
                this.$store.commit('RESET_TOAST');
                if (this.data_order.destination == '') {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: label_input + ' harus diisi',
                        tipe: 'default',
                        icon: 'danger',
                    });
                } else {
                    this.product_select = item;
                    this.data_order.product_id = item.product_id;
                    if (item.full_description) {
                        let element = this.$refs.modalDetailProduct.$el;
                        window.$(element).modal('show');
                    } else {
                        this.showConfirm(item);
                    }
                }
            },
            hideDetail() {
                let element = this.$refs.modalDetailProduct.$el;
                window.$(element).modal('hide');
            },
            showConfirm(item) {
                this.hideDetail();
                this.$store.commit('RESET_TOAST');
                if (this.data_order.destination != '') {
                    if (this.filterPriceSelling.length > 0) {
                        this.data_order.price_selling =
                            this.$options.filters.inputRupiah(
                                this.filterPriceSelling[0].price_selling
                            );
                    } else {
                        this.data_order.price_selling =
                            this.$options.filters.inputRupiah(item.price);
                    }

                    let element = this.$refs.modalConfirmation.$el;
                    window.$(element).modal('show');
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: 'No. Telepon tidak boleh kosong',
                        tipe: 'default',
                    });
                }
            },
            hideConfirm() {
                let element = this.$refs.modalConfirmation.$el;
                window.$(element).modal('hide');
            },
            getProduct() {
                this.loading.list_product = true;
                this.$store.commit('RESET_TOAST');
                $axios
                    .get('/prabayar/product-special/product', {
                        params: {
                            operator_id: this.data_operator_selected.id,
                            group_id: this.group_id,
                        },
                    })
                    .then(response => {
                        if (response.data.data.length > 0) {
                            this.product = response.data.data;
                        }
                        this.loading.list_product = false;
                    });
            },
            verifyWithoutPin() {
                this.loading.button_submit = true;
                this.addPriceSelling();
                $axios
                    .post('/prabayar/order', this.data_order)
                    .then(() => {
                        this.loading.button_submit = false;
                        this.RESET_DATA_ORDER();
                        this.operator = [];
                        this.product = [];
                        this.hideConfirm();
                        this.showStatus();
                    })
                    .catch(e => {
                        this.loading.button_submit = false;
                        if (
                            e.response.status == 400 &&
                            e.response.data.responseCode == 'AVAILABLE_UPDATE'
                        ) {
                            this.dialogUpdateAPK('show');
                        } else {
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        }
                        this.hideConfirm();
                    });
            },
            verifyWithPin() {
                this.addPriceSelling();
                this.hideConfirm();
                this.$router.push({
                    name: 'auth.pin.verify',
                    params: {
                        data_reference: this.data_order,
                        url_reference: '/prabayar/order',
                        previous_page_reference: 'prabayar-special-order',
                        params_previous_page_reference: {
                            id: this.data_operator_selected.id, // operator id
                            operator_selected: this.data_operator_selected, // kategori name
                            destination: this.data_order.destination,
                            group_id: this.group_id,
                        },
                        next_page_reference: 'prabayar-special-order',
                        params_next_page_reference: {
                            id: this.data_operator_selected.id, // operator id
                            operator_selected: this.data_operator_selected, // kategori name
                            group_id: this.group_id,
                        },
                    },
                });
                this.RESET_DATA_ORDER();
            },
            showStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('show');
            },
            hideStatus() {
                let element = this.$refs.status.$el;
                window.$(element).modal('hide');
                this.inAppReview();
            },
            directToHistory() {
                this.hideStatus();
                this.$router.push({
                    name: 'transaction.index',
                });
            },
            checkButton() {
                const label_input =
                    this.data_operator_selected.label_input != null
                        ? this.data_operator_selected.label_input
                        : 'No. Pengisian';
                this.$store.commit('RESET_TOAST');
                this.data_checking = {
                    nama_pelanggan: '',
                    tarif_daya: '',
                };
                if (this.data_order.destination != '') {
                    this.loading.button_check_pln = true;
                    $axios
                        .post('/prabayar/inquiry-pln', {
                            no_pelanggan: this.data_order.destination,
                        })
                        .then(response => {
                            this.data_checking.nama_pelanggan =
                                response.data.data.nama_pelanggan;
                            this.data_checking.tarif_daya =
                                response.data.data.tarif_daya;
                            this.loading.button_check_pln = false;
                        })
                        .catch(e => {
                            this.loading.button_check_pln = false;
                            this.$store.commit('SET_TOAST', {
                                show: true,
                                message: e.response.data.message,
                                tipe: 'default',
                                icon: 'danger',
                            });
                        });
                } else {
                    this.$store.commit('SET_TOAST', {
                        show: true,
                        message: label_input + ' harus diisi',
                        tipe: 'default',
                        icon: 'danger',
                    });
                }
            },

            inputPriceSelling() {
                this.data_order.price_selling =
                    this.$options.filters.inputRupiah(
                        this.data_order.price_selling
                    );
            },
            addPriceSelling() {
                const price = this.product_select.price;
                const price_selling = this.data_order.price_selling.replace(
                    /[^,\d]/g,
                    ''
                );
                if (price_selling != price) {
                    if (this.filterPriceSelling[0] == null) {
                        this.list_price_selling.push({
                            product_id: this.data_order.product_id,
                            price_selling: price_selling.replace(/[^,\d]/g, ''),
                        });
                    }
                    this.savePriceSelling();
                }
            },
            savePriceSelling() {
                this.$set(
                    this.list_price_selling,
                    this.list_price_selling.findIndex(
                        f => f.product_id === this.data_order.product_id
                    ),
                    {
                        product_id: this.data_order.product_id,
                        price_selling: this.data_order.price_selling.replace(
                            /[^,\d]/g,
                            ''
                        ),
                    }
                );
                const parsed = JSON.stringify(this.list_price_selling);
                localStorage.setItem('price_selling', parsed);
            },
            redirectDepositPage() {
                this.hideConfirm();
                this.$router.push({ name: 'deposit' });
            },
        },
        watch: {
            'data_order.destination': function () {
                // reset detail pelanggan
                this.data_checking = {
                    nama_pelanggan: '',
                    tarif_daya: '',
                };
            },
        },
        mounted() {
            if (
                this.operator_selected == undefined &&
                this.data_operator_selected.prabayar_category.product_name == ''
            ) {
                this.$router.go(-1);
            } else {
                if (this.operator_selected != undefined) {
                    this.SET_DATA_OPERATOR_SELECTED(this.operator_selected);
                }
                if (this.destination != undefined) {
                    this.data_order.destination = this.destination;
                }
                this.getProduct();
                this.loading.content = false;
            }

            setTimeout(() => {
                if (this.toast_reference != undefined) {
                    if (
                        this.toast_reference.show &&
                        this.toast_reference.icon == 'success'
                    ) {
                        this.showStatus();
                    } else {
                        this.$store.commit('SET_TOAST', this.toast_reference);
                    }
                }
            }, 500);

            if (localStorage.getItem('price_selling')) {
                try {
                    this.list_price_selling = JSON.parse(
                        localStorage.getItem('price_selling')
                    );
                } catch (e) {
                    localStorage.removeItem('price_selling');
                }
            }

            window['phone'] = phone => {
                this.phone(phone);
            };
        },
        destroyed() {
            this.$store.commit('RESET_TOAST');
            this.RESET_DATA_ORDER();
        },
        filters: {
            filterPhone: function (value, findArray, replaceArray) {
                var i,
                    regex = [],
                    map = {};
                for (i = 0; i < findArray.length; i++) {
                    regex.push(
                        findArray[i].replace(/([-[\]{}()*+?.\\^$|#,])/g, '\\$1')
                    );
                    map[findArray[i]] = replaceArray[i];
                }
                regex = regex.join('|');
                var destination = value.replace(
                    new RegExp(regex, 'g'),
                    function (matched) {
                        return map[matched];
                    }
                );
                return destination.replace(/ /g, '');
            },
            inputRupiah: function (value) {
                value = value.toString();
                var number_string = value.replace(/[^,\d]/g, '').toString(),
                    split = number_string.split(','),
                    sisa = split[0].length % 3,
                    rupiah = split[0].substr(0, sisa),
                    ribuan = split[0].substr(sisa).match(/\d{3}/gi);

                if (ribuan) {
                    var separator = sisa ? '.' : '';
                    rupiah += separator + ribuan.join('.');
                }

                rupiah =
                    split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
                return rupiah;
            },
        },
    };
</script>
